import React, { useEffect, useState } from "react";
import Header from "../../CustomComponents/Header/Header";
import Footer from "../../CustomComponents/Footer/Footer";
import { Link } from "react-router-dom";
import { showErrorToast, showSuccessToast } from "../../assets/toastUtils";
import PageMetaData from "../../CustomComponents/PageMetaData/PageMetaData";
import OgMetaTitles from "../../CustomComponents/PageMetaData/OgMetaTitles";
import NewFooterUI from "../../CustomComponents/NewComponents/NewFooterUI/NewFooterUI";
import NewUiHeader from "../../CustomComponents/NewComponents/NewUIHeader/NewUIHeader";
import sccanerImg from "../../assets/new-images/link_pro.png";

function ContactUs() {
  const [formErrors, setFormErrors] = useState({});

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    source: "website",
    content: "",
    source_type: "",
    type: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const postFormDataHandle = (e) => {
    e.preventDefault();
    const myHeaders = new Headers();
    const valid = validate();
    setTimeout(() => {
      setFormErrors({});
    }, 1500);
    if (!valid) {
      showErrorToast("Please fill the above details.");
      return;
    }

    myHeaders.append("Accept", "application/json");
    myHeaders.append("key", process.env.REACT_APP_API_KEY);
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      leadName: formData?.name,
      leadPhone: formData?.phone_number,
      leadEmail: formData?.email,
      leadDetail: formData?.message,
      leadSource: "Website",
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(`${process.env.REACT_APP_APP_URL}/api/v1/contact-us`, requestOptions)
      .then((response) => response.json())

      .then((result) => {
        if (result.success) {
          setFormData();
          showSuccessToast("Form Submitted Successfully");
        }
      })

      .catch((error) => console.error(error));
  };

  const validate = () => {
    const errors = {};
    // Add validation logic for each form field
    // if (currentStep === 1) {
    if (!formData.name.trim()) {
      errors.name = "required";
    }
    if (!formData.email.trim()) {
      errors.email = "required";
    }
    if (!formData.phone_number.trim()) {
      errors.phone_number = "required";
    }
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);
    myHeaders.append("Cookie", process.env.REACT_APP_COOKIE);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/website/query/create`,
        {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify(formData),
          redirect: "follow",
        }
      );
      const result = await response.json();
      if (result.success) {
        console.log(result);
        showSuccessToast(result.message || "Form submitted successfully!");
        setFormData({
          name: "",
          email: "",
          source: "website",
          phone_number: "",
          content: "",
          source_type: "",
          type: "",
        });
      } else {
        showErrorToast(
          result.message || "An error occurred. Please try again."
        );
        setFormData({
          name: "",
          email: "",
          source: "website",
          phone_number: "",
          content: "",
          source_type: "",
          type: "",
        });
      }
    } catch (error) {
      showErrorToast("An error occurred. Please try again.");
      console.error(error);
    }
  };

  return (
    <>
      <PageMetaData
        title="Contact Us | Mountain Mysteries – Reach Out for Assistance"
        description="Get in touch with Mountain Mysteries or personalized support, inquiries, or assistance. We're here to help via email, phone, or our contact form. Reach out today."
        // keywords="hotel management, RevCatalyst, property optimization"
      />
      <OgMetaTitles
        title="Contact Us | Mountain Mysteries – Reach Out for Assistance"
        type="Get in touch with Mountain Mysteries or personalized support, inquiries, or assistance. We're here to help via email, phone, or our contact form. Reach out today."
        url={`https://www.mountainmysteries.com/contact-us`}
      />
      <NewUiHeader />
      <section className="contactUsBg">
        <div className="container">
          <div className="main_div_flex">
            <div className="contact_info">
              <h3>Contact Us</h3>
              <div className="booking_query">
                <svg
                  width="36"
                  height="36"
                  viewBox="0 0 36 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <mask
                    id="mask0_6873_19150"
                    style={{ maskType: "alpha" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="36"
                    height="36"
                  >
                    <rect
                      x="0.5"
                      y="0.5"
                      width="35"
                      height="35"
                      fill="#D9D9D9"
                    />
                  </mask>
                  <g mask="url(#mask0_6873_19150)">
                    <path
                      d="M16.4674 26.1948L12.2999 22.0273L13.3488 20.9784L16.4674 24.097L22.6486 17.9159L23.6975 18.9648L16.4674 26.1948ZM8.68797 31.1251C8.01665 31.1251 7.45616 30.9003 7.00651 30.4506C6.55686 30.001 6.33203 29.4405 6.33203 28.7691V10.1477C6.33203 9.47637 6.55686 8.91588 7.00651 8.46623C7.45616 8.01658 8.01665 7.79175 8.68797 7.79175H11.2678V4.53857H12.8384V7.79175H23.2713V4.53857H24.7296V7.79175H27.3094C27.9807 7.79175 28.5412 8.01658 28.9909 8.46623C29.4405 8.91588 29.6654 9.47637 29.6654 10.1477V28.7691C29.6654 29.4405 29.4405 30.001 28.9909 30.4506C28.5412 30.9003 27.9807 31.1251 27.3094 31.1251H8.68797ZM8.68797 29.6667H27.3094C27.534 29.6667 27.7398 29.5733 27.9267 29.3864C28.1136 29.1995 28.207 28.9937 28.207 28.7691V15.981H7.79036V28.7691C7.79036 28.9937 7.88382 29.1995 8.07073 29.3864C8.25764 29.5733 8.46339 29.6667 8.68797 29.6667ZM7.79036 14.5223H28.207V10.1477C28.207 9.9231 28.1136 9.71736 27.9267 9.53045C27.7398 9.34354 27.534 9.25008 27.3094 9.25008H8.68797C8.46339 9.25008 8.25764 9.34354 8.07073 9.53045C7.88382 9.71736 7.79036 9.9231 7.79036 10.1477V14.5223Z"
                      fill="#009A50"
                    />
                  </g>
                </svg>

                <h5>fOR bOOKING/QUERY</h5>
                <a href="tel:+919816012966">+91 98160 12966</a>
                <a href="mailto:tours@mountainmysteries.com">
                tours@mountainmysteries.com
                </a>
              </div>
              <div className="booking_query">
                <svg
                  width="36"
                  height="36"
                  viewBox="0 0 36 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <mask
                    id="mask0_6873_19144"
                    style={{ maskType: "alpha" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="36"
                    height="36"
                  >
                    <rect
                      x="0.5"
                      y="0.5"
                      width="35"
                      height="35"
                      fill="#D9D9D9"
                    />
                  </mask>
                  <g mask="url(#mask0_6873_19144)">
                    <path
                      d="M18.0408 25.6282C18.3631 25.6282 18.6351 25.5169 18.8568 25.2942C19.0784 25.0716 19.1893 24.7991 19.1893 24.4768C19.1893 24.1543 19.078 23.8823 18.8553 23.6609C18.6327 23.4392 18.3601 23.3284 18.0376 23.3284C17.7153 23.3284 17.4433 23.4397 17.2216 23.6623C17.0002 23.885 16.8895 24.1576 16.8895 24.4801C16.8895 24.8024 17.0008 25.0744 17.2234 25.296C17.4461 25.5175 17.7185 25.6282 18.0408 25.6282ZM17.2876 20.7989H18.6956C18.7331 20.165 18.8522 19.6499 19.0529 19.2534C19.2539 18.8573 19.6676 18.3516 20.294 17.7364C20.9446 17.0857 21.4289 16.5029 21.7468 15.9879C22.0647 15.4728 22.2237 14.8766 22.2237 14.1992C22.2237 13.0498 21.8199 12.1339 21.0122 11.4514C20.2045 10.7691 19.2491 10.428 18.1458 10.428C17.097 10.428 16.2066 10.7131 15.4745 11.2833C14.7427 11.8535 14.2066 12.5088 13.8664 13.2491L15.2066 13.8044C15.4404 13.2735 15.7746 12.8043 16.2092 12.3967C16.644 11.9891 17.2708 11.7853 18.0897 11.7853C19.0357 11.7853 19.7265 12.0447 20.1623 12.5633C20.5979 13.0823 20.8157 13.6531 20.8157 14.2758C20.8157 14.7806 20.6792 15.2316 20.4063 15.6288C20.1333 16.0261 19.7781 16.4259 19.3406 16.8279C18.4955 17.6073 17.942 18.2682 17.6803 18.8105C17.4185 19.3527 17.2876 20.0155 17.2876 20.7989ZM18.0047 31.125C16.1898 31.125 14.4835 30.7806 12.8856 30.0918C11.288 29.403 9.89823 28.4682 8.71625 27.2874C7.53427 26.1066 6.59863 24.7181 5.90932 23.1217C5.21977 21.5255 4.875 19.8199 4.875 18.0047C4.875 16.1898 5.21941 14.4835 5.90823 12.8856C6.59705 11.288 7.53184 9.89823 8.7126 8.71625C9.89337 7.53427 11.2819 6.59863 12.8783 5.90932C14.4745 5.21977 16.1801 4.875 17.9953 4.875C19.8102 4.875 21.5165 5.21941 23.1144 5.90823C24.712 6.59705 26.1018 7.53184 27.2838 8.7126C28.4657 9.89337 29.4014 11.2819 30.0907 12.8783C30.7802 14.4745 31.125 16.1801 31.125 17.9953C31.125 19.8102 30.7806 21.5165 30.0918 23.1144C29.403 24.712 28.4682 26.1018 27.2874 27.2838C26.1066 28.4657 24.7181 29.4014 23.1217 30.0907C21.5255 30.7802 19.8199 31.125 18.0047 31.125ZM18 29.6667C21.2569 29.6667 24.0156 28.5365 26.276 26.276C28.5365 24.0156 29.6667 21.2569 29.6667 18C29.6667 14.7431 28.5365 11.9844 26.276 9.72396C24.0156 7.46354 21.2569 6.33333 18 6.33333C14.7431 6.33333 11.9844 7.46354 9.72396 9.72396C7.46354 11.9844 6.33333 14.7431 6.33333 18C6.33333 21.2569 7.46354 24.0156 9.72396 26.276C11.9844 28.5365 14.7431 29.6667 18 29.6667Z"
                      fill="#009A50"
                    />
                  </g>
                </svg>

                <h5>fOR sUPPORT</h5>
                <a href="tel:+919816633966">+91 98166 33966</a>
                <a href="mailto: info@mountainmysteries.com">
                  info@mountainmysteries.com
                </a>
              </div>
            </div>
            <div className="contact_div">
              <div>
                {" "}
                <h6>Follow us on:</h6>
                <div className="mt-10 flex flex_gap_5 justify_content_center">
                  <a
                    href="https://www.facebook.com/mountainmysteries.in"
                    target="_blank"
                  >
                    <svg
                      width="35"
                      height="35"
                      viewBox="0 0 25 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx="12.5" cy="12.5" r="12" stroke="#fff" />
                      <path
                        d="M13.75 13.4375H15.3125L15.9375 10.9375H13.75V9.6875C13.75 9.04375 13.75 8.4375 15 8.4375H15.9375V6.3375C15.7337 6.31063 14.9644 6.25 14.1519 6.25C12.455 6.25 11.25 7.28562 11.25 9.1875V10.9375H9.375V13.4375H11.25V18.75H13.75V13.4375Z"
                        fill="#fff"
                      />
                    </svg>
                  </a>
                  <a
                    href="https://www.instagram.com/mountainmysteries/"
                    target="_blank"
                  >
                    <svg
                      width="35"
                      height="35"
                      viewBox="0 0 25 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx="12.5" cy="12.5" r="12" stroke="#fff" />
                      <path
                        d="M9.875 6.25H15.125C17.125 6.25 18.75 7.875 18.75 9.875V15.125C18.75 16.0864 18.3681 17.0084 17.6883 17.6883C17.0084 18.3681 16.0864 18.75 15.125 18.75H9.875C7.875 18.75 6.25 17.125 6.25 15.125V9.875C6.25 8.91359 6.63192 7.99156 7.31174 7.31174C7.99156 6.63192 8.91359 6.25 9.875 6.25ZM9.75 7.5C9.15326 7.5 8.58097 7.73705 8.15901 8.15901C7.73705 8.58097 7.5 9.15326 7.5 9.75V15.25C7.5 16.4937 8.50625 17.5 9.75 17.5H15.25C15.8467 17.5 16.419 17.2629 16.841 16.841C17.2629 16.419 17.5 15.8467 17.5 15.25V9.75C17.5 8.50625 16.4937 7.5 15.25 7.5H9.75ZM15.7812 8.4375C15.9885 8.4375 16.1872 8.51981 16.3337 8.66632C16.4802 8.81284 16.5625 9.01155 16.5625 9.21875C16.5625 9.42595 16.4802 9.62466 16.3337 9.77118C16.1872 9.91769 15.9885 10 15.7812 10C15.574 10 15.3753 9.91769 15.2288 9.77118C15.0823 9.62466 15 9.42595 15 9.21875C15 9.01155 15.0823 8.81284 15.2288 8.66632C15.3753 8.51981 15.574 8.4375 15.7812 8.4375ZM12.5 9.375C13.3288 9.375 14.1237 9.70424 14.7097 10.2903C15.2958 10.8763 15.625 11.6712 15.625 12.5C15.625 13.3288 15.2958 14.1237 14.7097 14.7097C14.1237 15.2958 13.3288 15.625 12.5 15.625C11.6712 15.625 10.8763 15.2958 10.2903 14.7097C9.70424 14.1237 9.375 13.3288 9.375 12.5C9.375 11.6712 9.70424 10.8763 10.2903 10.2903C10.8763 9.70424 11.6712 9.375 12.5 9.375ZM12.5 10.625C12.0027 10.625 11.5258 10.8225 11.1742 11.1742C10.8225 11.5258 10.625 12.0027 10.625 12.5C10.625 12.9973 10.8225 13.4742 11.1742 13.8258C11.5258 14.1775 12.0027 14.375 12.5 14.375C12.9973 14.375 13.4742 14.1775 13.8258 13.8258C14.1775 13.4742 14.375 12.9973 14.375 12.5C14.375 12.0027 14.1775 11.5258 13.8258 11.1742C13.4742 10.8225 12.9973 10.625 12.5 10.625Z"
                        fill="#fff"
                      />
                    </svg>
                  </a>

                  <a
                    href="https://www.youtube.com/channel/UCLCvoKy9UnH6f8nvax44R8w"
                    target="_blank"
                  >
                    <svg
                      width="35"
                      height="35"
                      viewBox="0 0 25 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx="12.5" cy="12.5" r="12" stroke="#fff" />
                      <path
                        d="M17.2544 9.37187C17.2069 9.18562 17.0719 9.045 16.9175 9.00187C16.6438 8.925 15.3131 8.75 12.5006 8.75C9.68813 8.75 8.35813 8.925 8.0825 9.00187C7.93 9.04437 7.795 9.185 7.74688 9.37187C7.67875 9.63687 7.50062 10.7469 7.50062 12.5C7.50062 14.2525 7.67875 15.3625 7.74688 15.6287C7.79437 15.8144 7.92938 15.955 8.08313 15.9975C8.35812 16.075 9.6875 16.25 12.5 16.25C15.3125 16.25 16.6431 16.075 16.9181 15.9981C17.0706 15.9556 17.2056 15.815 17.2538 15.6281C17.3225 15.3631 17.5 14.25 17.5 12.5C17.5 10.75 17.3225 9.6375 17.2544 9.37187ZM18.4644 9.06125C18.75 10.175 18.75 12.5 18.75 12.5C18.75 12.5 18.75 14.825 18.4644 15.9388C18.3056 16.5544 17.8412 17.0387 17.2531 17.2025C16.1856 17.5 12.5 17.5 12.5 17.5C12.5 17.5 8.81687 17.5 7.74688 17.2025C7.15625 17.0363 6.6925 16.5525 6.53563 15.9388C6.25 14.825 6.25 12.5 6.25 12.5C6.25 12.5 6.25 10.175 6.53563 9.06125C6.69438 8.44563 7.15875 7.96125 7.74688 7.7975C8.8175 7.5 12.5006 7.5 12.5006 7.5C12.5006 7.5 16.1856 7.5 17.2538 7.7975C17.8438 7.96375 18.3081 8.4475 18.465 9.06125M11.2506 14.6875V10.3125L15.0006 12.5L11.2506 14.6875Z"
                        fill="#fff"
                      />
                    </svg>
                  </a>
                </div>
              </div>
              <div>
                {" "}
                <span>
                  Tag @mountainmysteries & <br /> Share your memories with us{" "}
                </span>
                <div className="flex justify_content_center mt-10">
                  <img src={sccanerImg} alt="scanner" />
                </div>
              </div>
            </div>
            {/* <div className="form_div">
              <form action="" onSubmit={handleSubmit}>
                <div className="input-flex">
                  <div>
                    <label htmlFor="">Name:</label>
                    <input
                      style={
                        formErrors.name && {
                          backgroundColor: "#ff000040",
                          border: "1px solid red",
                        }
                      }
                      type="text"
                      className="w-full"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div>
                    <label htmlFor="">Email Address:</label>
                    <input
                      style={
                        formErrors.email && {
                          backgroundColor: "#ff000040",
                          border: "1px solid red",
                        }
                      }
                      type="text"
                      className="w-full"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
                <div className="input-flex">
                  <div>
                    <label htmlFor="source_type">Are you Agent:</label>
                    <select
                      style={
                        formErrors.source_type && {
                          backgroundColor: "#ff000040",
                          border: "1px solid red",
                        }
                      }
                      className="w-full"
                      name="source_type"
                      value={formData.source_type}
                      onChange={handleInputChange}
                    >
                      <option value="" disabled>
                        Select an option
                      </option>
                      <option value="agent">Yes</option>
                      <option value="customer">No</option>
                    </select>
                  </div>
                  <div>
                    <label htmlFor="type">Type:</label>
                    <select
                      style={
                        formErrors.source_type && {
                          backgroundColor: "#ff000040",
                          border: "1px solid red",
                        }
                      }
                      className="w-full"
                      name="type"
                      value={formData.type}
                      onChange={handleInputChange}
                    >
                      <option value="" disabled>
                        Select an option
                      </option>
                      <option value="package">Package</option>
                      <option value="activity">Activity</option>
                      <option value="transport">Transport</option>
                      <option value="hotel">Hotel</option>
                      <option value="other">Other</option>
                    </select>
                  </div>
                </div>
                <label htmlFor="">Message:</label>
                <textarea
                  style={
                    formErrors.message && {
                      backgroundColor: "#ff000040",
                      border: "1px solid red",
                    }
                  }
                  name="message"
                  value={formData.content}
                  onChange={handleInputChange}
                  id=""
                  className="w-full mt-5"
                  rows={3}
                ></textarea>
                <button
                  className="primary_btn mt-10"
                  style={{ width: "120px" }}
                  type="submit"
                >
                  Send Message
                </button>
              </form>
            </div> */}
          </div>
        </div>
      </section>
      <section>
        <div>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d19329.323566599684!2d77.1652166431102!3d31.082651808258305!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3905827257abaaab%3A0x2cc0362740358b96!2sMountain%20Mysteries!5e0!3m2!1sen!2sin!4v1722243527259!5m2!1sen!2sin"
            width="100%"
            height="340"
            style={{ border: "0" }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </section>

      <NewFooterUI />
      {/* <Footer /> */}
    </>
  );
}

export default ContactUs;
